import { toTitleCase } from "../../util/toTitleCase";

/**
 * Force Logout Confirmation Modal
 * Shows warning about credentials being cleared and requires confirmation
 */
const ForceLogoutModal = ({
  isOpen,
  isLoading,
  error,
  clientName,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={() => !isLoading && onCancel()}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "480px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <span
            style={{
              fontSize: "2rem",
              color: "#dc3545",
            }}
          >
            ⚠️
          </span>
          <h2
            style={{
              margin: 0,
              color: "#333",
              fontSize: "1.4rem",
            }}
          >
            Force Logout Client?
          </h2>
        </div>

        {/* Description */}
        <p
          style={{
            color: "#555",
            lineHeight: "1.6",
            marginBottom: "8px",
          }}
        >
          Are you sure you want to force logout{" "}
          <strong>{toTitleCase(clientName)}</strong> from the MyCompass app?
        </p>

        {/* Warning Box */}
        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "8px",
            padding: "12px",
            marginBottom: "20px",
          }}
        >
          <p
            style={{
              color: "#856404",
              margin: 0,
              fontSize: "0.95rem",
              lineHeight: "1.5",
            }}
          >
            <strong>Important:</strong> This will clear the client&apos;s saved
            login credentials on their device. They will need to enter their{" "}
            <strong>email and password</strong> to log in again. Face ID / Touch
            ID will not work until they re-enter their credentials.
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div
            style={{
              backgroundColor: "#f8d7da",
              border: "1px solid #f5c6cb",
              borderRadius: "8px",
              padding: "12px",
              marginBottom: "16px",
              color: "#721c24",
            }}
          >
            {error}
          </div>
        )}

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#333",
              cursor: isLoading ? "not-allowed" : "pointer",
              fontSize: "1rem",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#dc3545",
              color: "#fff",
              cursor: isLoading ? "not-allowed" : "pointer",
              fontSize: "1rem",
              fontWeight: "600",
              opacity: isLoading ? 0.6 : 1,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {isLoading ? (
              <>
                <span
                  style={{
                    display: "inline-block",
                    width: "16px",
                    height: "16px",
                    border: "2px solid #fff",
                    borderTopColor: "transparent",
                    borderRadius: "50%",
                    animation: "forceLogoutSpin 1s linear infinite",
                  }}
                />
                Logging Out...
              </>
            ) : (
              "Yes, Force Logout"
            )}
          </button>
        </div>
      </div>

      {/* Spinner animation */}
      <style>{`
        @keyframes forceLogoutSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ForceLogoutModal;

